import { useLocation } from "react-router-dom";
import LanguageToggle from "./LanguageToggle";

/** Global floating language control — omitted where the page nav includes an inline `LanguageToggle`. */
export default function FixedLanguageToggle() {
  const { pathname } = useLocation();
  if (
    pathname === "/" ||
    pathname.startsWith("/listings") ||
    pathname.startsWith("/car/") ||
    pathname.startsWith("/dealers") ||
    pathname.startsWith("/dealer/") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/dashboard") ||
    pathname.startsWith("/sell") ||
    pathname.startsWith("/account")
  ) {
    return null;
  }
  return <LanguageToggle fixed />;
}
